/**
 * @fileoverview GET handler for the "/data_objects/:type_name/:object_id/unlinked_users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdUnlinkedUsers } from "./constants";
import type {
  CustomObjectsTypeNameObjectIdUnlinkedUsersParams,
  CustomObjectsTypeNameObjectIdUnlinkedUsersResponse,
} from "./types";

export const getCustomObjectsTypeNameObjectIdUnlinkedUsers = reactQueryFetcherAdapter(
  customObjectsTypeNameObjectIdUnlinkedUsers,
  (
    signal: AbortSignal,
    {
      appGroupId,
      typeName,
      objectId,
      userIdentifier,
      pageNumber = 1,
    }: CustomObjectsTypeNameObjectIdUnlinkedUsersParams
  ): Promise<CustomObjectsTypeNameObjectIdUnlinkedUsersResponse> => {
    return fetch<CustomObjectsTypeNameObjectIdUnlinkedUsersResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/unlinked_users`,
      "GET",
      {
        app_group_id: appGroupId,
        user_identifier: userIdentifier,
        page_number: pageNumber,
      },
      { signal }
    );
  }
);
